import jwtService from '@/services/common/jwt.service';
import $http from '@/services/common/http.service';

export class GoalService {
  public async loadGoals(data: {
    coachId?: string;
    coachClientId?: string;
  }) {
    const user = await jwtService.getUser();
    const response = await $http.query(
      `admins/${user.id}/reports/client_goals`,
      data
    );
    return response.data.data as string[];
  }
}

const goalService = new GoalService();
export default goalService;
